export default function FacebookShareButton({ title, text }) {
    const shareUrl = new URL("https://www.facebook.com/sharer/sharer.php");
    shareUrl.searchParams.set("u", window.location.href);
    shareUrl.searchParams.set("quote", title);

    return (
        <a
            className="facebook-share-btn"
            href={shareUrl.toString()}
            target="_blank"
            rel="noopener noreferrer"
        >
            {text.shareOnFacebook}
        </a>
    );
}
